import React, { useState, useEffect, useCallback, useRef } from 'react';
import { FiPaperclip, FiX, FiFileText } from 'react-icons/fi';
import styles from '../Lead.module.css';
import { buscarChecklistLead, atualizarDocumentoLead, anexarDocumentoLead, STATUS_DOCUMENTO } from '../../../../services/leadDocumentos';
import { abrirArquivo } from '../../../../services/arquivos';
import { fluxoPorId } from '../fluxos';

/* Checklist de documentos do fluxo do lead: cada item com status, anexo e
   observação. Os itens vêm do cadastro (botão "Modelos e checklist" na
   lista de Leads). `fluxo` é o escolhido na tela agora -- se mudou e ainda
   não foi salvo, avisa em vez de mostrar o checklist do fluxo antigo. */
function ChecklistDocumentos({ leadId, fluxo }) {
  const [dados, setDados] = useState({ fluxo: null, items: [] });
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(null);
  const inputArquivo = useRef(null);
  const alvoArquivo = useRef(null);

  const carregar = useCallback(() => {
    setCarregando(true); setErro('');
    return buscarChecklistLead(leadId).then(setDados).catch(e => setErro(e.message)).finally(() => setCarregando(false));
  }, [leadId]);
  useEffect(() => { carregar(); }, [carregar]);

  const trocar = (doc) => setDados(d => ({ ...d, items: d.items.map(x => (x.id === doc.id ? { ...x, ...doc } : x)) }));

  async function salvar(id, campos) {
    setErro('');
    try { trocar(await atualizarDocumentoLead(id, campos)); } catch (e) { setErro(e.message); }
  }
  function escolherArquivo(doc) {
    alvoArquivo.current = doc;
    inputArquivo.current.value = '';
    inputArquivo.current.click();
  }
  async function aoEscolherArquivo(e) {
    const file = e.target.files?.[0];
    const doc = alvoArquivo.current;
    if (!file || !doc) return;
    setEnviando(doc.id); setErro('');
    try { trocar(await anexarDocumentoLead(doc.id, leadId, file)); } catch (err) { setErro(err.message); }
    setEnviando(null);
  }
  async function abrir(doc) {
    try { await abrirArquivo(doc.arquivo_path); } catch (e) { setErro(e.message); }
  }

  if (carregando) return <p className={styles.leadSecaoSub}>Carregando checklist...</p>;
  if (fluxo && dados.fluxo !== fluxo) {
    return <p className={styles.leadSecaoSub}>O fluxo mudou para <strong>{fluxoPorId(fluxo)?.curto}</strong>. Salve o lead para carregar o checklist dele.</p>;
  }
  if (!dados.fluxo) return <p className={styles.leadSecaoSub}>Escolha o tipo de fluxo (etapa 1) para ver o checklist de documentos.</p>;

  const recebidos = dados.items.filter(d => d.status !== 'pendente').length;
  return (
    <div className={styles.checklist}>
      <p className={styles.leadSecaoSub} style={{ margin: 0 }}>
        {recebidos} de {dados.items.length} resolvidos · itens do fluxo {fluxoPorId(dados.fluxo)?.curto}
      </p>
      {erro && <p className={styles.avisoReceitaErro}>{erro}</p>}
      <input ref={inputArquivo} type="file" hidden onChange={aoEscolherArquivo} />
      {dados.items.length === 0 && <p className={styles.leadSecaoSub}>Nenhum item cadastrado para este fluxo.</p>}
      {dados.items.map(doc => (
        <div key={doc.id} className={`${styles.checkItem} ${styles[`checkItem_${doc.status}`] || ''}`}>
          <div className={styles.checkLinha}>
            <span className={styles.checkNome}>{doc.nome}</span>
            <div className={styles.checkStatus}>
              {STATUS_DOCUMENTO.map(s => (
                <button key={s.id} type="button"
                  className={`${styles.checkStatusBtn} ${doc.status === s.id ? styles[`checkStatusAtivo_${s.id}`] : ''}`}
                  onClick={() => doc.status !== s.id && salvar(doc.id, { status: s.id })}>
                  {s.label}
                </button>
              ))}
            </div>
          </div>
          <div className={styles.checkLinha}>
            {doc.arquivo_path ? (
              <span className={styles.checkArquivo}>
                <button type="button" className={styles.checkLinkArquivo} onClick={() => abrir(doc)} title="Abrir">
                  <FiFileText size={13} /> {doc.arquivo_nome || 'arquivo'}
                </button>
                <button type="button" className={styles.checkTirar} title="Tirar o anexo"
                  onClick={() => salvar(doc.id, { arquivo_path: null })}><FiX size={12} /></button>
              </span>
            ) : (
              <button type="button" className={styles.checkAnexar} onClick={() => escolherArquivo(doc)} disabled={enviando === doc.id}>
                <FiPaperclip size={13} /> {enviando === doc.id ? 'Enviando...' : 'Anexar'}
              </button>
            )}
            <input className={styles.checkObs} placeholder="Observação" defaultValue={doc.observacao || ''}
              onBlur={e => { if ((e.target.value.trim() || null) !== (doc.observacao || null)) salvar(doc.id, { observacao: e.target.value }); }} />
          </div>
        </div>
      ))}
    </div>
  );
}

export default ChecklistDocumentos;
